import { Badge } from "@loot-os/ui/components/badge";

export function PurchaseStatusBadge({ status }: { status: string }) {
  const variant =
    status === "completed"
      ? "default"
      : status === "pending"
        ? "secondary"
        : status === "failed"
          ? "outline"
          : "destructive"; // refunded / disputed want eyes on them
  return <Badge variant={variant}>{status}</Badge>;
}
